import React, { ReactNode } from 'react';
import {ComponentProps} from '@episerver/spa-core/EpiComponent';
import CellcomNotFoundPageData from '../../Models/Content/CellcomNotFoundPageData';
import Property from '@episerver/spa-core/Components/Property';
import { isMobile } from 'react-device-detect';

const CellcomNotFoundPage = ({data, context}: ComponentProps<CellcomNotFoundPageData>) => (
    <div className='CellcomNotFoundPage'>
      <div className="d-flex justify-content-center">
        {isMobile 
          ? <Property iContent={data} field='imageMobile' context={context} />
          : <Property iContent={data} field='imageDesktop' context={context} />
        }
      </div>
      <Property iContent={data} field='text' context={context} />
    </div>
  );
  
  export default CellcomNotFoundPage;